import React, { useEffect } from "react";
import UnregisteredCompanyUser from "../misc/UnregisteredCompanyUser";
import RegisteredUser from "../misc/RegisteredUser";
import { setTitle } from "../../../store/slices/navbar";
import AnimatedPage from "../../../components/animation/AnimatedPage";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_company_details } from "../../../service/api/company";
import { Loader } from "../../../components/animation/Loader";

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(({ auth }) => auth.user);
  const company = useAppSelector(({ company }) => company.company);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const fetchCompany = async () => {
      if (!user) return;
      setLoading(true);
      try {
        await get_company_details(dispatch);
      } catch (error) {
        console.error("Error fetching company details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompany();
  }, [dispatch, user]);

  const hasCompany = !!company;

  const onLoad = React.useCallback(() => {
    dispatch(setTitle("Dashboard"));
  }, [dispatch]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  // Show loading state while checking
  if (loading) {
    return (
      <AnimatedPage className="mb-12">
        <Loader />
      </AnimatedPage>
    );
  }

  return (
    <AnimatedPage className="mb-12">
      {hasCompany ? <RegisteredUser /> : <UnregisteredCompanyUser />}
    </AnimatedPage>
  );
};

export default Dashboard;
